<template>
  <q-page class="q-pa-sm">
    <StockWiseTabbedStatistics
      :symbol="symbol"
      :isSignalType="isSignalType"
      :signalTypeData="buysellData"
    />
  </q-page>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";

import useData from "src/use/data";
import StockWiseTabbedStatistics from "src/components/StockWiseTabbedStatistics.vue";

const { buySellSearch } = useData();

const $route = useRoute();
const symbol = ref($route.query.symbol);

const buysellData = ref({});
const isSignalType = ref(false);

const loadData = (symbol) => {
  if (symbol) {
    buySellSearch(symbol).then((res) => {
      isSignalType.value = res.data[0].sell_date === null;
      buysellData.value = isSignalType.value ? res.data[0] : {};
    });
  }
};

watch($route, (to, from) => {
  if (to?.query?.symbol) {
    symbol.value = to.query.symbol;
    loadData(symbol.value);
  }
});

onMounted(() => {
  loadData(symbol.value);
});
</script>
